<template>
  <div class="excellent-works">
    <div class="tabs-wrapper">
      <div class="tabs-box">
        <span>分类</span>
        <span
            :class="{ 'box-active': tab.id === activeKey }"
            v-for="(tab, index) in tabList"
            :key="index"
            @click="handleClickActive(tab.id)"
        >{{ tab.typeName }}</span
        >
      </div>
    </div>
    <div class="tabs-wrapper" v-if="0">
      <div class="tabs-box">
        <span>阶段</span>
        <span
            :class="{ 'box-active': tab.id === activeKey }"
            v-for="(tab, index) in plateList"
            :key="index"
            @click="handleClickActive(tab.id)"
        >{{ tab.name }}</span
        >
      </div>
    </div>

    <course-list :cList="cList"></course-list>
  </div>
</template>
<script>
import CourseList from "@/components/CourseList";
export default {
  name: "TabsModule",
  components: {
    CourseList,
  },
  props: {
    plateList:Array,
    categoryList: Array,
    courseList: Array,
  },
  data() {
    return {
      activeKey: "",
      imgList: [
        { url: require("@/assets/img/tab-1.png") },
        { url: require("@/assets/img/tab-2.png") },
      ],
      tabList: [],
    };
  },
  computed: {
    cList() {
      return this.courseList;
    },
  },
  watch: {
    categoryList: {
      handler(newVal) {
        this.activeKey = this.categoryList[0].id;
        this.tabList = newVal;
      },
    },
  },
  methods: {
    handleClickActive(index) {
      console.log(index);
      this.activeKey = index;
      this.$emit("handleClickTab", index);
    },
  },
};
</script>

<style lang="scss">
.excellent-works {
  .tabs-wrapper {
    margin: 0 auto;
    height: 100px;
    .tabs-box {
      margin: 0 auto;
      width: 1280px;
      //display: flex;
      //justify-content: space-around;
      line-height: 42px;
      span {
        border-radius: 5px;
        border:1px solid #fff;
        margin-left: 0;
        margin-right: 11px;
        padding: 3px 10px;
        flex-grow: 1;
        font-size: 15px;
        background: #fff;
      }
      .box-active {
        background: #DF764533;
        //border-bottom: 3px solid #da514e;
        //color: #da514e;
      }
    }
  }
  .box-active {
    border-bottom: 3px solid #da514e;
    color: #da514e;
  }
}
</style>
